import { updateCardLinkBehavior } from '../utils.js';

export default function staticManagedSponsors() {
  const widgetName = 'staticManagedSponsors';
  const widgetOpts = staticManagedSponsorsOpts;
  const $widgetHTML = $(`#${widgetName}`);

  const wrapContainerClass = 'sponsors-wrap-container';

  const enableHeading = true;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    link: ['all'],
    hasImages: true,
    lazyLoadImages: true,
    imageIsBackground: false,
    textOverImage: true,
    maxItemsVisible: 8,
    itemsPerPanel: 1,
    buyNowButton: false,
    moreButton: false,
    showDescription: false,
    cardWidgetLoaded: function (data, _owl, hasData) {
      const cards = $(`#${widgetName} .card-widget-item`);
      if (hasData) {
        cards.find('.card-content').remove();
        updateCardLinkBehavior(data, cards);
        sponsorLayout();
      } else {
        $widgetHTML.remove();
      }
    },
  });

  // *********************************************************
  // Function Helper
  function sponsorLayout() {
    $(`#${widgetName}`)
      .wrap(`<div class="${wrapContainerClass}"></div>`)
      .wrap('<div class="inner-container"></div>');

    if (enableHeading) {
      $(`.${wrapContainerClass}`).prepend($('.static-sponsors-heading'));
    }
  }
}
